export default function SvgVideo8() {
    return (
      <>
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="#000"
      version="1.1"
      viewBox="0 0 511.984 511.984"
      xmlSpace="preserve"
    >
      <path d="M256.144 101.928c-26.048 0-47.232 21.344-47.232 47.6 0 26.24 21.184 47.584 47.232 47.584s47.232-21.344 47.232-47.584c0-26.256-21.184-47.6-47.232-47.6zm0 79.2c-17.216 0-31.232-14.176-31.232-31.584 0-17.44 14.016-31.6 31.232-31.6s31.232 14.176 31.232 31.6c0 17.408-14.016 31.584-31.232 31.584zM299.504 216.408l-43.36 32.976-43.36-32.976c-53.376 16.16-52.704 70.672-52.704 70.672h192.128s.672-54.512-52.704-70.672z"></path>
      <path d="M466.976 43.976H45.152c-22.864 0-41.456 18.896-41.456 42.096v224.912c0 23.2 18.592 42.096 41.456 42.096h421.824v-.016c22.848 0 41.424-18.896 41.424-42.096V86.072c0-23.2-18.576-42.096-41.424-42.096zm25.408 267.008c0 14.384-11.408 26.096-25.424 26.096H45.152c-14.032-.016-25.456-11.712-25.456-26.112V86.072c0-14.384 11.424-26.096 25.456-26.096H466.96c14.016 0 25.424 11.696 25.424 26.096v224.912zM451.12 420.808c-3.664-17.808-19.296-31.184-38.032-31.184S378.72 403 375.056 420.808H0v16h375.056c3.664 17.808 19.296 31.2 38.032 31.2s34.368-13.392 38.032-31.2h60.864v-16H451.12zm-38.032 31.2c-12.608 0-22.848-10.4-22.848-23.2 0-12.784 10.256-23.2 22.848-23.2s22.848 10.4 22.848 23.2c.016 12.8-10.24 23.2-22.848 23.2z"></path>
    </svg>
    </>
  );
}